export enum Color {
  white = 'white',
  black = 'black',
  darkGrey = 'darkGrey',
  lightGrey = 'lightGrey',
  red = 'red',
  grey = 'grey',
}

export type ButtonColor = Color | 'primary' | 'secondary';

export enum ButtonVariant {
  default = 'default',
  stroke = 'stroke',
  none = 'none',
}

export enum Days {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum AdminRole {
  Superadmin = 'Superadmin',
  Admin = 'Admin',
}

export enum MeasurmentType {
  Amounts = 'Amounts',
  ItemTypes = 'ItemTypes',
  CookingTimes = 'CookingTimes',
  MealTypes = 'MealTypes',
  Feelings = 'Feelings',
  Categories = 'Categories',
}
